import React from 'react';

import Feed from "../../Feed";

const SubscriptionsTab = ({ subscriptions, user, channels, location }) => {
  const { uid, userClaims } = user;
  
  let filteredChannels = [];
  const subscriptionsKey = subscriptions && uid &&
    Object.keys(subscriptions).filter(key => key === uid);

  if (subscriptionsKey && subscriptionsKey.length !== 0) {
    const subscribedChannels = subscriptions[subscriptionsKey[0]];

    filteredChannels = subscribedChannels && channels && channels.filter(function(event){
      return this.indexOf(event.id) >= 0
    }, subscribedChannels);
  }

  let FeedList = (
    <Feed
      list={filteredChannels}
      addButtonCaption={"Add channel"}
      renderType={"channels"}
      location={location}
    />
  );
  if (userClaims.userType === 'Admin') {
    FeedList = (
      <Feed
        list={channels}
        addButtonCaption={"Add channel"}
        renderType={"channels"}
        location={location}
      />
    );
  }

  return (
    <div className="tab-content">
      { FeedList }
    </div>
  );
}

export default SubscriptionsTab;


// WEBPACK FOOTER //
// ./src/pages/MyProfile/SubscriptionsTab/index.js